import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

type BrandProps = {
  inverse?: boolean;
};

export function Brand({ inverse = false }: BrandProps) {
  const { messages } = useI18n();

  return (
    <Link
      className={`brand${inverse ? " brand--inverse" : ""}`}
      to="/"
      aria-label={messages.brand.homeLabel}
      dir="ltr"
    >
      <span>SOURCE</span>
      <span className="brand__slash">/</span>
      <span>SAND</span>
    </Link>
  );
}
